<dx-box
    #invoiceWorkflowSearchBox
    height="100%"
    width="100%"
    direction="col"
    class="cc-search-grid-container"
    [elementAttr]="{ id: 'invoiceWorkflowSearchBox' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item [ratio]="1">
        <cc-data-grid-features
            #gridFeatures
            [stateConfig]="{ storageKey: 'INVOICE_WORKFLOW_SEARCH_GRID', storeGroupings: true }"
            [gridFeatures]="{ allowGrouping: true }"
            [dataSource]="invoiceWorkflows"
        >
            <dx-data-grid appHasInternalUserColumns width="100%" height="100%" [dataSource]="invoiceWorkflows">
                <dxo-search-panel [text]="searchText"></dxo-search-panel>
                <dxi-column dataField="location" caption="Location" dataType="string"></dxi-column>
                <dxi-column
                    dataField="community"
                    dataType="string"
                    caption="Community"
                    cellTemplate="communityTemplate"
                    groupCellTemplate="groupCellTemplate"
                ></dxi-column>
                <dxi-column dataField="wfJobId" dataType="number" caption="Workflow Id"></dxi-column>
                <dxi-column dataField="invoiceNumber" dataType="string" caption="Invoice Number"></dxi-column>
                <dxi-column
                    dataField="invoiceAmount"
                    dataType="number"
                    caption="Invoice Amount"
                    [format]="currencyFormat"
                ></dxi-column>
                <dxi-column
                    dataField="invoiceDate"
                    dataType="date"
                    caption="Invoice Date"
                    [format]="dateFormat"
                ></dxi-column>
                <dxi-column dataField="vendorName" dataType="string" caption="Vendor"></dxi-column>
                <dxi-column
                    dataField="invoice"
                    caption="Invoice"
                    alignment="center"
                    cellTemplate="invoiceTemplate"
                ></dxi-column>
                <dxi-column
                    name="InternalNotes"
                    dataField="hasNotes"
                    dataType="boolean"
                    caption="Notes"
                    alignment="center"
                    cellTemplate="notesTemplate"
                ></dxi-column>
                <dxi-column
                    name="InternalLogs"
                    caption="Log"
                    alignment="center"
                    cellTemplate="logTemplate"
                ></dxi-column>
                <dxi-column dataField="wfJobStatus" dataType="string" caption="Workflow Status"></dxi-column>
                <dxi-column dataField="paymentStatus" dataType="string" caption="Payment Status"></dxi-column>

                <div *dxTemplate="let cell of 'communityTemplate'">
                    <app-property-community-link
                        [communityId]="cell.data.communityId"
                        [displayText]="cell.value"
                    ></app-property-community-link>
                </div>

                <div *dxTemplate="let cell of 'invoiceTemplate'">
                    <div *ngIf="!!cell.data.invoice && !!cell.data.invoice.fileName">
                        <div class="cc-hyperlink" (click)="onDownloadCellClick(cell.data)">
                            <i class="cc-1-5x" [ngClass]="getFileIconByExtension(cell.data.invoice.fileName)"></i>
                        </div>
                    </div>
                </div>

                <div *dxTemplate="let cell of 'notesTemplate'">
                    <div *ngIf="cell.data.hasNotes">
                        <i
                            class="cc-1-5x cc-icon-content cc-icon-check cc-hyperlink"
                            [ngClass]="iconNotes"
                            (click)="onNotesClick(cell.data)"
                        ></i>
                    </div>
                    <div *ngIf="!cell.data.hasNotes">
                        <i
                            class="cc-1-5x dx-theme-accent-as-text-color cc-hyperlink"
                            [ngClass]="iconEmptyNotes"
                            (click)="onNotesClick(cell.data)"
                        ></i>
                    </div>
                </div>

                <div *dxTemplate="let cell of 'logTemplate'">
                    <div class="link-content cc-hyperlink">
                        <i
                            class="cc-1-5x dx-theme-accent-as-text-color"
                            [ngClass]="iconLog"
                            (click)="onLogClick(cell.data)"
                        ></i>
                    </div>
                </div>

                <div *dxTemplate="let groupdata of 'groupCellTemplate'">
                    <div class="community-group">
                        Community:&nbsp;
                        <app-property-community-link
                            [communityId]="getCommunityId(groupdata.data)"
                            [displayText]="groupdata.value"
                        ></app-property-community-link>
                    </div>
                </div>

                <dxo-summary>
                    <dxi-group-item
                        column="workFlowJobId"
                        summaryType="count"
                        displayFormat="Count = {0}"
                    ></dxi-group-item>
                </dxo-summary>
            </dx-data-grid>
        </cc-data-grid-features>
    </dxi-item>
</dx-box>

<dx-load-panel
    [position]="{ of: !widgetId ? 'body' : '#invoiceWorkflowSearchBox' + widgetId }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-search-transaction-log
    *ngIf="showTransactionLog"
    [visible]="showTransactionLog"
    [logId]="invoiceHistoryParam.processId"
    [communityId]="invoiceHistoryParam.communityId"
    [transactionLogData]="transactionLogData"
    [columnDef]="invoicesColumnDef"
    (onCloseClick)="onTransactionLogclose()"
></app-search-transaction-log>

<app-search-notes-editor
    #notesEditor
    *ngIf="showNotesEditor"
    [visible]="showNotesEditor"
    [previousNotes]="previousNotes"
    [taskId]="invoiceNotesParam.processId"
    (onNoteSave)="onNoteSave($event)"
    (onNotesEditorClose)="onNotesEditorClose()"
></app-search-notes-editor>
